<app-activity
  *ngIf="id"
  [model]="'offers/offers'"
  [modelId]="id"
></app-activity>
